import styled from '@emotion/styled';

export const TableLoading = styled.tbody`

`;
